<template>
  <div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "picker",
  data() {
    return {
      columns: [],
      showPicker: false,
    }
  },
  methods: {
    onConfirm(value, index) {
      this.$emit('confirm', value, index);
      this.close();
    },

    open() {
      this.showPicker = true;
    },
    close() {
      this.showPicker = false;
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/plugins/dialog/picker.vue